// This file is auto-generated! Do not modify it directly.
export const iconList = {
  icons: {
    StepBackward: 'StepBackward',
    StepForward: 'StepForward',
    FastBackward: 'FastBackward',
    FastForward: 'FastForward',
    Shrink: 'Shrink',
    ArrowsAlt: 'ArrowsAlt',
    Down: 'Down',
    Up: 'Up',
    Left: 'Left',
    Right: 'Right',
    CaretUp: 'CaretUp',
    CaretDown: 'CaretDown',
    CaretLeft: 'CaretLeft',
    CaretRight: 'CaretRight',
    UpCircle: 'UpCircle',
    DownCircle: 'DownCircle',
    LeftCircle: 'LeftCircle',
    RightCircle: 'RightCircle',
    DoubleRight: 'DoubleRight',
    DoubleLeft: 'DoubleLeft',
    VerticalLeft: 'VerticalLeft',
    VerticalRight: 'VerticalRight',
    VerticalAlignTop: 'VerticalAlignTop',
    VerticalAlignMiddle: 'VerticalAlignMiddle',
    VerticalAlignBottom: 'VerticalAlignBottom',
    Forward: 'Forward',
    Backward: 'Backward',
    Rollback: 'Rollback',
    Enter: 'Enter',
    Retweet: 'Retweet',
    Swap: 'Swap',
    ArrowUp: 'ArrowUp',
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    PlayCircle: 'PlayCircle',
    UpSquare: 'UpSquare',
    DownSquare: 'DownSquare',
    LeftSquare: 'LeftSquare',
    RightSquare: 'RightSquare',
    Login: 'Login',
    Logout: 'Logout',
    Fullscreen: 'Fullscreen',
    FullscreenExit: 'FullscreenExit',
    Question: 'Question',
    QuestionCircle: 'QuestionCircle',
    Plus: 'Plus',
    PlusCircle: 'PlusCircle',
    PauseCircle: 'PauseCircle',
    MinusCircle: 'MinusCircle',
    PlusSquare: 'PlusSquare',
    MinusSquare: 'MinusSquare',
    Info: 'Info',
    InfoCircle: 'InfoCircle',
    Exclamation: 'Exclamation',
    ExclamationCircle: 'ExclamationCircle',
    Close: 'Close',
    CloseCircle: 'CloseCircle',
    CloseSquare: 'CloseSquare',
    Check: 'Check',
    CheckCircleOutlined: 'CheckCircleOutlined',
    CheckCircle: 'CheckCircle',
    CheckSquareOutlined: 'CheckSquareOutlined',
    CheckSquare: 'CheckSquare',
    ClockCircle: 'ClockCircle',
    Warning: 'Warning',
    IssuesClose: 'IssuesClose',
    Stop: 'Stop',
    Edit: 'Edit',
    Form: 'Form',
    Copy: 'Copy',
    Scissor: 'Scissor',
    Delete: 'Delete',
    Snippets: 'Snippets',
    Diff: 'Diff',
    Highlight: 'Highlight',
    BgColors: 'BgColors',
    Redo: 'Redo',
    Undo: 'Undo',
    ZoomIn: 'ZoomIn',
    ZoomOut: 'ZoomOut',
    Drag: 'Drag',
    UnorderedList: 'UnorderedList',
    AreaChart: 'AreaChart',
    PieChartOutlined: 'PieChartOutlined',
    PieChart: 'PieChart',
    BarChart: 'BarChart',
    DotChart: 'DotChart',
    LineChart: 'LineChart',
    RadarChart: 'RadarChart',
    HeatMap: 'HeatMap',
    Fall: 'Fall',
    Rise: 'Rise',
    Stock: 'Stock',
    BoxPlot: 'BoxPlot',
    FundOutlined: 'FundOutlined',
    Fund: 'Fund',
    Sliders: 'Sliders',
    Aim: 'Aim',
    Alert: 'Alert',
    Apartment: 'Apartment',
    Api: 'Api',
    AppstoreAdd: 'AppstoreAdd',
    AppstoreOutlined: 'AppstoreOutlined',
    Appstore: 'Appstore',
    Audio: 'Audio',
    AudioMuted: 'AudioMuted',
    Audit: 'Audit',
    Bank: 'Bank',
    Barcode: 'Barcode',
    Bars: 'Bars',
    Bell: 'Bell',
    Block: 'Block',
    Book: 'Book',
    Border: 'Border',
    BorderlessTable: 'BorderlessTable',
    Branches: 'Branches',
    Bug: 'Bug',
    Build: 'Build',
    Bulb: 'Bulb',
    Calculator: 'Calculator',
    CalendarOutlined: 'CalendarOutlined',
    Calendar: 'Calendar',
    Camera: 'Camera',
    Car: 'Car',
    CarryOut: 'CarryOut',
    Clear: 'Clear',
    CloudDownload: 'CloudDownload',
    Cloud: 'Cloud',
    CloudServer: 'CloudServer',
    CloudSync: 'CloudSync',
    CloudUpload: 'CloudUpload',
    Cluster: 'Cluster',
    Code: 'Code',
    Coffee: 'Coffee',
    Comment: 'Comment',
    CompassOutlined: 'CompassOutlined',
    Compass: 'Compass',
    Compress: 'Compress',
    ConsoleSql: 'ConsoleSql',
    Contacts: 'Contacts',
    Container: 'Container',
    Control: 'Control',
    CreditCard: 'CreditCard',
    Crown: 'Crown',
    CustomerService: 'CustomerService',
    DashboardOutlined: 'DashboardOutlined',
    Dashboard: 'Dashboard',
    Database: 'Database',
    DeliveredProcedure: 'DeliveredProcedure',
    DeploymentUnit: 'DeploymentUnit',
    Desktop: 'Desktop',
    Disconnect: 'Disconnect',
    Dislike: 'Dislike',
    DollarCircle: 'DollarCircle',
    Download: 'Download',
    EnvironmentOutlined: 'EnvironmentOutlined',
    Environment: 'Environment',
    EuroCircle: 'EuroCircle',
    Exception: 'Exception',
    Experiment: 'Experiment',
    Export: 'Export',
    EyeOutlined: 'EyeOutlined',
    Eye: 'Eye',
    EyeInvisible: 'EyeInvisible',
    FieldTime: 'FieldTime',
    FileAdd: 'FileAdd',
    FileDone: 'FileDone',
    FileExcel: 'FileExcel',
    FileExclamation: 'FileExclamation',
    File: 'File',
    FileImageOutlined: 'FileImageOutlined',
    FileImage: 'FileImage',
    FileProtect: 'FileProtect',
    FileSearch: 'FileSearch',
    FileSync: 'FileSync',
    FileTextOutlined: 'FileTextOutlined',
    FileText: 'FileText',
    FileUnknown: 'FileUnknown',
    Filter: 'Filter',
    Fire: 'Fire',
    Flag: 'Flag',
    FolderAdd: 'FolderAdd',
    Folder: 'Folder',
    FolderOpen: 'FolderOpen',
    FolderView: 'FolderView',
    Fork: 'Fork',
    FormatPainter: 'FormatPainter',
    Frown: 'Frown',
    FundProjectionScreen: 'FundProjectionScreen',
    FundView: 'FundView',
    FunnelPlot: 'FunnelPlot',
    Gift: 'Gift',
    Global: 'Global',
    Gold: 'Gold',
    Group: 'Group',
    Hdd: 'Hdd',
    HeartOutlined: 'HeartOutlined',
    Heart: 'Heart',
    History: 'History',
    HomeOutlined: 'HomeOutlined',
    Home: 'Home',
    Hourglass: 'Hourglass',
    Idcard: 'Idcard',
    Import: 'Import',
    Inbox: 'Inbox',
    Interaction: 'Interaction',
    Key: 'Key',
    Laptop: 'Laptop',
    Layout: 'Layout',
    Like: 'Like',
    Link: 'Link',
    Lock: 'Lock',
    MacCommand: 'MacCommand',
    Mail: 'Mail',
    Man: 'Man',
    MedicineBox: 'MedicineBox',
    Meh: 'Meh',
    MessageOutlined: 'MessageOutlined',
    Message: 'Message',
    Mobile: 'Mobile',
    Monitor: 'Monitor',
    Notification: 'Notification',
    Number: 'Number',
    PaperClip: 'PaperClip',
    Partition: 'Partition',
    Phone: 'Phone',
    Picture: 'Picture',
    PlaySquare: 'PlaySquare',
    Pound: 'Pound',
    Poweroff: 'Poweroff',
    Printer: 'Printer',
    Profile: 'Profile',
    Project: 'Project',
    Pushpin: 'Pushpin',
    Qrcode: 'Qrcode',
    Read: 'Read',
    ReconciliationOutlined: 'ReconciliationOutlined',
    Reconciliation: 'Reconciliation',
    Reload: 'Reload',
    Rest: 'Rest',
    Robot: 'Robot',
    Rocket: 'Rocket',
    SafetyCertificate: 'SafetyCertificate',
    Safety: 'Safety',
    Save: 'Save',
    Schedule: 'Schedule',
    Search: 'Search',
    SecurityScan: 'SecurityScan',
    Select: 'Select',
    Send: 'Send',
    Setting: 'Setting',
    Shake: 'Shake',
    ShareAlt: 'ShareAlt',
    ShopOutlined: 'ShopOutlined',
    Shop: 'Shop',
    ShoppingCart: 'ShoppingCart',
    Shopping: 'Shopping',
    Skin: 'Skin',
    SmileOutlined: 'SmileOutlined',
    Smile: 'Smile',
    Solution: 'Solution',
    Sound: 'Sound',
    StarOutlined: 'StarOutlined',
    Star: 'Star',
    Switcher: 'Switcher',
    Sync: 'Sync',
    Table: 'Table',
    Tablet: 'Tablet',
    Tag: 'Tag',
    Tags: 'Tags',
    Team: 'Team',
    Thunderbolt: 'Thunderbolt',
    ToTop: 'ToTop',
    Tool: 'Tool',
    TrophyOutlined: 'TrophyOutlined',
    Trophy: 'Trophy',
    Unlock: 'Unlock',
    Upload: 'Upload',
    Usb: 'Usb',
    User: 'User',
    VideoCamera: 'VideoCamera',
    Wallet: 'Wallet',
    WhatsApp: 'WhatsApp',
    Wifi: 'Wifi',
    Woman: 'Woman',
    Signal: 'Signal',
    Android: 'Android',
    Apple: 'Apple',
    Windows: 'Windows',
    Github: 'Github',
    Twitter: 'Twitter',
    Wechat: 'Wechat',
    Youtube: 'Youtube',
    Linkedin: 'Linkedin',
    Facebook: 'Facebook',
    Amazon: 'Amazon',
    Google: 'Google',
    Slack: 'Slack',
    Instagram: 'Instagram',
    Reddit: 'Reddit',
  },
};
